import React from 'react';
import { viewGenAIView as ViewGenAIView } from './viewGenAIView';
import { fetch } from '../../modules/httpServices';
import APP from '../../modules/index';
// import { cloneDeep } from 'lodash';

class ViewGenAIComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showRequirement: true,
      parsedRequirement: [],
      editVal: false,
      openModal: false,
      requirementRadio: 'TestData',
      modalData: '',
      dataVal: '',
      isLoading: false,
      totalRecords: 0,
      currentPage: 0,
      pageLimit: 10
    };
  }

  componentDidMount() {
    const TestDataManagement = localStorage.getItem('TestDataManagement');
    // const TestDesign = localStorage.getItem('TestDesign');
    const TestCheck = sessionStorage.getItem('TestCheck');
    if (TestDataManagement === 'true' && TestCheck === 'TestData') {
      this.setState({dataVal: 'TestData'}, () => this.viewData());
      // this.viewData('TestData');
    } else {
      this.setState({dataVal: 'TestDesign'}, () => this.viewData());
      // this.viewData('TestDesign');
    }
  }

  pageChangeData = (data, currentPage, pageLimit) => {
    this.setState({
      currentPage: currentPage,
      pageLimit: pageLimit,
      parsedRequirement: data
    });
    this.viewData(currentPage, pageLimit);
  };

  viewData = (id, limit) => {
    const { pageLimit, dataVal } = this.state;
    let pageNumber = id ? id : 0;
    let Limit = limit ? limit : pageLimit;
    const userEmail = localStorage.getItem('email');
    fetch.get({
      // url: APP.Constants.SERVICE_URLS.GET_GPT_DATA + dataVal + '/' + userEmail + '/1/10',
      url: `${APP.Constants.SERVICE_URLS.GET_GPT_DATA + dataVal}/${userEmail}/${pageNumber}/${Limit}`,
      callbackHandler: (res) => {
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
          this.setState({
            parsedRequirement: payload?.content,
            totalRecords: payload?.totalElements,
            currentPage: payload?.number,
            requirementRadio: dataVal
          });
        } else {
          this.setState({ parsedRequirement: [] });
        }
      }
    });
  };

  onEditClicked = (eve, item) => {
    sessionStorage.setItem('checkId', JSON.stringify(item));
    this.props.goToPage(APP.Constants.ROUTES.TEST_CONFIG);
  };

  closePopup = () => {
    this.setState({ openModal: false });
  };

  openModalData = (data) => {
    this.setState({ openModal: true, modalData: data });
  };

  render() {
    return (
      <ViewGenAIView
        {...{
          ...this.state,
          openModalData: this.openModalData,
          onEditClicked: this.onEditClicked,
          closePopup: this.closePopup,
          changeData: this.pageChangeData,
          viewParsedRequirement: this.viewParsedRequirement
        }}
      />
    );
  }
}

export default ViewGenAIComponent;
